import { ADD_GROUP_REQUEST, ADD_GROUP_FAILURE } from '../constants/add_group.constants';

export const addGroup = params => ({ type: ADD_GROUP_REQUEST, params });
export const addGroupFailure = error => ({ type: ADD_GROUP_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_create/redux/actions/add_group.actions.js